// ============ 分类定义 ============
export const categories = [
  { slug: 'dianshiju', name: '电视剧', icon: 'ri-tv-line' },
  { slug: 'dianying', name: '电影', icon: 'ri-film-line' },
  { slug: 'dongman', name: '动漫', icon: 'ri-emotion-line' },
  { slug: 'zongyi', name: '综艺', icon: 'ri-live-line' },
  { slug: 'jilupian', name: '纪录片', icon: 'ri-camera-line' },
];

// ============ 影视数据 ============
export interface Show {
  id: string;
  title: string;
  categorySlug: string;
  categoryName: string;
  subcategory: string;
  image: string;
  description: string;
  longDescription: string;
  rating: number;
  year: number;
  episodes: string;
  actors: string[];
  director: string;
  region: string;
  language: string;
  updateDay: string;
  isHot: boolean;
  isNew: boolean;
  tags: string[];
  releaseDate: string;
  duration: string;
}

export const shows: Show[] = [
  {
    id: '1',
    title: '长安十二时辰',
    categorySlug: 'dianshiju',
    categoryName: '电视剧',
    subcategory: '古装悬疑',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20city%20at%20night%20with%20lanterns%20and%20traditional%20architecture%2C%20cinematic%20warm%20amber%20lighting%2C%20mysterious%20atmosphere%2C%20stylized%20illustration%20with%20rich%20textures%2C%20deep%20shadows%20and%20golden%20highlights%2C%20Tang%20dynasty%20aesthetic&width=800&height=600&seq=show-changan&orientation=landscape',
    description: '唐朝上元节前夕，长安城陷入危机，死囚张小敬临危受命，与李必联手在十二时辰内拯救长安。',
    longDescription: '故事发生在唐朝天宝三年，上元节前夕，长安城混入可疑狼卫。死囚张小敬被靖安司司丞李必从牢中提出，命其在十二时辰内侦破此案、拯救长安。随着调查深入，一场更大的阴谋浮出水面。该剧以精良的制作、紧凑的剧情和深厚的历史底蕴，成为近年来国产古装剧的标杆之作。',
    rating: 8.2,
    year: 2019,
    episodes: '48集全',
    actors: ['雷佳音', '易烊千玺', '周一围', '热依扎'],
    director: '曹盾',
    region: '中国大陆',
    language: '汉语普通话',
    updateDay: '已完结',
    isHot: true,
    isNew: false,
    tags: ['古装', '悬疑', '历史', '动作'],
    releaseDate: '2019-06-27',
    duration: '45分钟/集',
  },
  {
    id: '2',
    title: '狂飙',
    categorySlug: 'dianshiju',
    categoryName: '电视剧',
    subcategory: '刑侦反腐',
    image: 'https://readdy.ai/api/search-image?query=Dark%20urban%20Chinese%20cityscape%20at%20night%20with%20neon%20lights%20reflecting%20on%20wet%20streets%2C%20crime%20drama%20moody%20atmosphere%2C%20stylized%20cinematic%20illustration%20with%20deep%20contrast%2C%20noir%20aesthetic%20with%20blue%20and%20orange%20tones&width=800&height=600&seq=show-kuangbiao&orientation=landscape',
    description: '刑警安欣与黑恶势力展开长达二十年的生死较量，正义与邪恶的终极对决震撼人心。',
    longDescription: '2000年，刑警安欣在调查一起案件时结识了鱼贩高启强。随着时间推移，高启强逐渐偏离正轨，建立起庞大的黑恶势力。安欣在长达二十年的时间里，始终坚持正义，与黑恶势力展开不懈斗争。该剧以扣人心弦的剧情和深刻的社会洞察，引发了全国观众的热烈讨论，成为现象级爆款剧集。',
    rating: 8.5,
    year: 2023,
    episodes: '39集全',
    actors: ['张译', '张颂文', '李一桐', '张志坚'],
    director: '徐纪周',
    region: '中国大陆',
    language: '汉语普通话',
    updateDay: '已完结',
    isHot: true,
    isNew: false,
    tags: ['刑侦', '反腐', '剧情', '犯罪'],
    releaseDate: '2023-01-14',
    duration: '45分钟/集',
  },
  {
    id: '3',
    title: '庆余年 第二季',
    categorySlug: 'dianshiju',
    categoryName: '电视剧',
    subcategory: '古装传奇',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20courtyard%20with%20blooming%20cherry%20blossoms%2C%20traditional%20rooftops%20in%20misty%20morning%20light%2C%20martial%20arts%20fantasy%20atmosphere%2C%20stylized%20illustration%20with%20soft%20warm%20colors%2C%20elegant%20and%20heroic%20composition&width=800&height=600&seq=show-qingyunian2&orientation=landscape',
    description: '范闲归来，京都风云再起！朝堂权谋、江湖恩怨，一场更大的棋局正在展开。',
    longDescription: '范闲从北齐归来后，发现京都的局势已经发生了翻天覆地的变化。庆帝的布局更加深远，各方势力蠢蠢欲动。在第二季中，范闲将面临更严峻的考验——朝堂上的明争暗斗、江湖中的恩怨情仇、以及自身身世之谜的逐渐揭开。一场惊心动魄的传奇故事正在继续。',
    rating: 7.9,
    year: 2024,
    episodes: '36集全',
    actors: ['张若昀', '李沁', '陈道明', '吴刚'],
    director: '孙皓',
    region: '中国大陆',
    language: '汉语普通话',
    updateDay: '已完结',
    isHot: true,
    isNew: true,
    tags: ['古装', '传奇', '权谋', '喜剧'],
    releaseDate: '2024-05-16',
    duration: '45分钟/集',
  },
  {
    id: '4',
    title: '繁花',
    categorySlug: 'dianshiju',
    categoryName: '电视剧',
    subcategory: '都市剧情',
    image: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20cityscape%20with%20vintage%20neon%20signs%20and%20busy%20street%20markets%2C%20golden%20nostalgic%20lighting%2C%20retro%20Chinese%20urban%20scene%20with%20art%20deco%20buildings%2C%20stylized%20illustration%20with%20warm%20amber%20tones%2C%20romantic%20old%20Shanghai%20vibe&width=800&height=600&seq=show-fanhua&orientation=landscape',
    description: '九十年代的上海，阿宝在商海沉浮中书写了一段传奇人生，黄河路上的故事永不落幕。',
    longDescription: '九十年代初的上海，煌煌大时代，人人争上游。阿宝凭借自己的智慧和魄力，在商海中闯出一片天地，成为黄河路上无人不知的"宝总"。从街头到高楼，从平凡到传奇，阿宝的人生交织着情感与利益的纠葛。王家卫导演用独特的镜头语言，讲述了一个关于时代、命运与选择的故事。',
    rating: 8.7,
    year: 2023,
    episodes: '30集全',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    director: '王家卫',
    region: '中国大陆',
    language: '汉语普通话/沪语',
    updateDay: '已完结',
    isHot: true,
    isNew: false,
    tags: ['都市', '剧情', '年代', '商战'],
    releaseDate: '2023-12-27',
    duration: '46分钟/集',
  },
  {
    id: '5',
    title: '三体',
    categorySlug: 'dianshiju',
    categoryName: '电视剧',
    subcategory: '科幻',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20alien%20planet%20with%20three%20suns%20in%20the%20sky%2C%20sci-fi%20cosmic%20landscape%20with%20strange%20geometric%20structures%2C%20mysterious%20atmosphere%20with%20purple%20and%20golden%20nebula%2C%20stylized%20illustration%20with%20deep%20space%20vibes%2C%20epic%20scale&width=800&height=600&seq=show-sancti&orientation=landscape',
    description: '纳米科学家汪淼被卷入一场跨越星际的危机，人类文明面临前所未有的挑战。',
    longDescription: '2007年，地球基础科学出现异常扰动，纳米科学家汪淼被警官史强带到联合作战中心，潜入名为"科学边界"的组织协助调查。在调查过程中，汪淼接触到了一个名为"三体"的VR游戏，并逐渐揭开了一个惊天秘密——地外文明"三体"正在逼近地球，人类的命运悬于一线。',
    rating: 8.4,
    year: 2023,
    episodes: '30集全',
    actors: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    director: '杨磊',
    region: '中国大陆',
    language: '汉语普通话',
    updateDay: '已完结',
    isHot: true,
    isNew: false,
    tags: ['科幻', '悬疑', '剧情', '改编'],
    releaseDate: '2023-01-15',
    duration: '45分钟/集',
  },
  {
    id: '6',
    title: '流浪地球2',
    categorySlug: 'dianying',
    categoryName: '电影',
    subcategory: '科幻灾难',
    image: 'https://readdy.ai/api/search-image?query=Massive%20spaceship%20engines%20on%20frozen%20Earth%20surface%2C%20sci-fi%20blockbuster%20scene%20with%20giant%20mechanical%20structures%2C%20apocalyptic%20winter%20landscape%20with%20blue%20and%20orange%20contrast%2C%20stylized%20illustration%20with%20epic%20cinematic%20composition%2C%20human%20civilization%20fighting%20for%20survival&width=800&height=600&seq=show-liulang2&orientation=landscape',
    description: '太阳即将毁灭，人类在地球表面建造巨型推进器，开启长达2500年的星际流浪之旅。',
    longDescription: '在不远的将来，太阳急速衰老膨胀，整个太阳系将被吞没。为了生存，人类提出"流浪地球"计划——在地球表面建造上万座行星发动机，带着地球逃离太阳系，前往4.2光年外的新家园。影片展现了人类在绝境中的勇气与智慧，以及跨越时空的亲情羁绊。',
    rating: 8.3,
    year: 2023,
    episodes: '173分钟',
    actors: ['吴京', '刘德华', '李雪健', '沙溢'],
    director: '郭帆',
    region: '中国大陆',
    language: '汉语普通话',
    updateDay: '已上映',
    isHot: true,
    isNew: false,
    tags: ['科幻', '灾难', '冒险', '视觉'],
    releaseDate: '2023-01-22',
    duration: '173分钟',
  },
  {
    id: '7',
    title: '哪吒之魔童降世',
    categorySlug: 'dongman',
    categoryName: '动漫',
    subcategory: '神话奇幻',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20child%20warrior%20with%20flaming%20wheels%20and%20red%20silk%20ribbons%2C%20dynamic%20action%20pose%20in%20ancient%20Chinese%20sky%20with%20swirling%20clouds%2C%20stylized%203D%20animation%20style%20with%20vibrant%20reds%20and%20golds%2C%20dramatic%20lighting&width=800&height=600&seq=show-nezha&orientation=landscape',
    description: '天地灵气孕育出混元珠，元始天尊将其提炼成灵珠和魔丸。阴差阳错下，魔丸投胎为哪吒。',
    longDescription: '天地灵气孕育出一颗混元珠，元始天尊将其提炼成灵珠和魔丸。灵珠投胎为人，助周伐纣；魔丸则会诞出魔王，为祸人间。然而阴差阳错，灵珠和魔丸被调换，哪吒成为魔丸转世。面对众人的偏见和天劫的降临，哪吒以"我命由我不由天"的信念，谱写了一段逆天改命的热血传奇。',
    rating: 8.4,
    year: 2019,
    episodes: '110分钟',
    actors: ['吕艳婷', '囧森瑟夫', '陈浩'],
    director: '饺子',
    region: '中国大陆',
    language: '汉语普通话',
    updateDay: '已上映',
    isHot: true,
    isNew: false,
    tags: ['神话', '奇幻', '动作', '喜剧'],
    releaseDate: '2019-07-26',
    duration: '110分钟',
  },
  {
    id: '8',
    title: '奔跑吧 第十二季',
    categorySlug: 'zongyi',
    categoryName: '综艺',
    subcategory: '户外真人秀',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20outdoor%20variety%20show%20scene%20with%20celebrities%20running%20on%20a%20bright%20sunny%20field%2C%20energetic%20and%20fun%20atmosphere%20with%20vibrant%20colors%2C%20stylized%20illustration%20with%20playful%20composition%2C%20game%20show%20vibe&width=800&height=600&seq=show-benpaoba&orientation=landscape',
    description: '跑男团再次集结！全新游戏、爆笑挑战、精彩对决，欢乐不停歇！',
    longDescription: '《奔跑吧》第十二季强势回归！本季跑男团将前往全国各地，体验各具特色的文化与游戏挑战。从智力比拼到体力较量，从爆笑互动到温情时刻，每一期都充满了惊喜与感动。全新成员加入，经典游戏升级，让你笑到停不下来！',
    rating: 7.5,
    year: 2024,
    episodes: '更新至第18期',
    actors: ['李晨', '郑恺', '沙溢', '白鹿', '周深'],
    director: '',
    region: '中国大陆',
    language: '汉语普通话',
    updateDay: '每周五更新',
    isHot: false,
    isNew: true,
    tags: ['真人秀', '户外', '搞笑', '竞技'],
    releaseDate: '2024-04-19',
    duration: '90分钟/期',
  },
  {
    id: '9',
    title: '舌尖上的中国 第四季',
    categorySlug: 'jilupian',
    categoryName: '纪录片',
    subcategory: '美食',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20cuisine%20close-up%20with%20steaming%20hot%20dishes%20on%20wooden%20table%2C%20traditional%20kitchen%20with%20warm%20lighting%2C%20artistic%20food%20photography%20style%2C%20rich%20textures%20and%20appetizing%20colors%2C%20cultural%20heritage%20atmosphere&width=800&height=600&seq=show-shejian4&orientation=landscape',
    description: '探访中国各地美食，从田间到餐桌，讲述人与食物的温暖故事。',
    longDescription: '《舌尖上的中国》第四季继续踏上美食之旅，深入中国各地的山川湖海，探寻最地道的美食文化。本季将聚焦于传统手艺人的坚守、地方小吃的传承、以及食物背后的人情故事。每一道菜都承载着一段记忆，每一口味道都连接着一方水土。',
    rating: 8.9,
    year: 2024,
    episodes: '8集全',
    actors: [],
    director: '陈晓卿',
    region: '中国大陆',
    language: '汉语普通话',
    updateDay: '已完结',
    isHot: false,
    isNew: true,
    tags: ['美食', '文化', '人文', '传统'],
    releaseDate: '2024-01-05',
    duration: '50分钟/集',
  },
  {
    id: '10',
    title: '封神第一部',
    categorySlug: 'dianying',
    categoryName: '电影',
    subcategory: '神话史诗',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20battle%20scene%20with%20ancient%20warriors%20in%20armor%2C%20dramatic%20skies%20with%20lightning%20and%20storm%20clouds%2C%20grand%20scale%20fantasy%20warfare%2C%20stylized%20illustration%20with%20golden%20and%20crimson%20tones%2C%20heroic%20silhouettes&width=800&height=600&seq=show-fengshen&orientation=landscape',
    description: '商王殷寿暴虐无道，姬发觉醒反商，一场人神交织的封神大战拉开序幕。',
    longDescription: '商朝末年，纣王殷寿暴虐无道，引发天怒人怨。西伯侯之子姬发在朝歌为质期间，逐渐看清纣王的真面目，与姜子牙、哪吒、杨戬等人联手，踏上了反抗暴政的道路。影片以宏大的视觉效果和深刻的人物刻画，重新诠释了中国神话史诗。',
    rating: 7.8,
    year: 2023,
    episodes: '148分钟',
    actors: ['费翔', '李雪健', '黄渤', '于适'],
    director: '乌尔善',
    region: '中国大陆',
    language: '汉语普通话',
    updateDay: '已上映',
    isHot: false,
    isNew: false,
    tags: ['神话', '史诗', '奇幻', '动作'],
    releaseDate: '2023-07-20',
    duration: '148分钟',
  },
  {
    id: '11',
    title: '琅琊榜',
    categorySlug: 'dianshiju',
    categoryName: '电视剧',
    subcategory: '古装权谋',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20scholar%20in%20white%20robes%20standing%20on%20a%20mountain%20cliff%20overlooking%20misty%20valleys%2C%20traditional%20ink%20wash%20painting%20aesthetic%2C%20elegant%20and%20contemplative%20atmosphere%2C%20stylized%20illustration%20with%20soft%20muted%20tones&width=800&height=600&seq=show-langyabang&orientation=landscape',
    description: '十二年前的赤焰军冤案，梅长苏以病弱之躯重返京都，搅动朝堂风云，还天下公道。',
    longDescription: '十二年前，七万赤焰军被奸人所害，含冤覆灭于梅岭。少帅林殊侥幸存活，历经削皮挫骨之痛，化身为江左盟宗主梅长苏。十二年后，他以病弱之躯重返帝都，凭借无双智谋，搅动朝堂风云，扶持明君靖王登上皇位，最终为七万赤焰忠魂洗雪冤屈。权谋之中，是家国天下；风雨之间，是赤子之心。',
    rating: 9.4,
    year: 2015,
    episodes: '54集全',
    actors: ['胡歌', '刘涛', '王凯', '陈龙'],
    director: '孔笙',
    region: '中国大陆',
    language: '汉语普通话',
    updateDay: '已完结',
    isHot: true,
    isNew: false,
    tags: ['古装', '权谋', '剧情', '经典'],
    releaseDate: '2015-09-19',
    duration: '45分钟/集',
  },
  {
    id: '12',
    title: '深海',
    categorySlug: 'dongman',
    categoryName: '动漫',
    subcategory: '奇幻冒险',
    image: 'https://readdy.ai/api/search-image?query=Dreamlike%20underwater%20world%20with%20colorful%20coral%20reefs%20and%20glowing%20jellyfish%2C%20magical%20deep%20sea%20fantasy%20with%20swirling%20ink-like%20currents%2C%20stylized%20Chinese%20animation%20aesthetic%20with%20vibrant%20colors%2C%20surreal%20and%20beautiful%20composition&width=800&height=600&seq=show-shenhai&orientation=landscape',
    description: '少女参宿误入深海世界，在神秘海底饭店中开启了一段奇幻冒险和自我救赎之旅。',
    longDescription: '父母离异后，少女参宿一直生活在压抑之中。一次游轮旅行中，她意外坠入大海，醒来时发现自己身处一个奇妙的深海世界。在这里，她遇到了神秘的海底饭店老板南河，以及一群古怪可爱的海底生物。在这场如梦似幻的冒险中，参宿逐渐找到了面对现实的勇气。影片以惊艳的粒子水墨画风，创造了一个令人叹为观止的视觉奇迹。',
    rating: 7.8,
    year: 2023,
    episodes: '112分钟',
    actors: ['苏鑫', '王亭文', '滕奎兴'],
    director: '田晓鹏',
    region: '中国大陆',
    language: '汉语普通话',
    updateDay: '已上映',
    isHot: false,
    isNew: false,
    tags: ['奇幻', '冒险', '治愈', '视觉'],
    releaseDate: '2023-01-22',
    duration: '112分钟',
  },
  {
    id: '13',
    title: '鬼灭之刃 柱训练篇',
    categorySlug: 'dongman',
    categoryName: '动漫',
    subcategory: '热血战斗',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20warrior%20with%20water%20dragon%20effects%20in%20traditional%20Japanese%20setting%2C%20dynamic%20action%20scene%20with%20dramatic%20lighting%2C%20stylized%20illustration%20with%20vibrant%20blues%20and%20warm%20accents%2C%20epic%20battle%20composition&width=800&height=600&seq=show-guimie&orientation=landscape',
    description: '炭治郎等人接受柱的严格训练，为最终决战做准备。热血与成长的故事仍在继续！',
    longDescription: '在锻刀村之战后，炭治郎的日轮刀受损，身体也达到了极限。为了迎接与无惨的最终决战，产屋敷耀哉下令开启"柱训练"——由九柱亲自指导，全面提升鬼杀队成员的实力。炭治郎和伙伴们将面临前所未有的挑战，每个人都必须在极限中突破自我。',
    rating: 8.6,
    year: 2024,
    episodes: '更新至第6集',
    actors: ['花江夏树', '鬼头明里', '下野纮'],
    director: '外崎春雄',
    region: '日本',
    language: '日语',
    updateDay: '每周日更新',
    isHot: true,
    isNew: true,
    tags: ['热血', '战斗', '奇幻', '成长'],
    releaseDate: '2024-05-12',
    duration: '24分钟/集',
  },
  {
    id: '14',
    title: '满江红',
    categorySlug: 'dianying',
    categoryName: '电影',
    subcategory: '古装悬疑',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20military%20camp%20courtyard%20at%20night%20with%20lanterns%20and%20soldiers%2C%20suspenseful%20atmosphere%20with%20narrow%20alleyways%2C%20stylized%20illustration%20with%20deep%20reds%20and%20dark%20shadows%2C%20mysterious%20and%20tense%20composition&width=800&height=600&seq=show-manjianghong&orientation=landscape',
    description: '南宋绍兴年间，一场围绕秦桧的惊天阴谋在宰相府邸中层层揭开。',
    longDescription: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。一夜间，金国使者死在宰相府邸，所携密信不翼而飞。小兵张大与亲兵营副统领孙均被卷入这场阴谋之中，被迫在有限时间内找出真相。随着调查的深入，一个更大的秘密浮出水面——那封密信的内容，竟与岳飞的《满江红》有关。',
    rating: 7.4,
    year: 2023,
    episodes: '159分钟',
    actors: ['沈腾', '易烊千玺', '张译', '雷佳音'],
    director: '张艺谋',
    region: '中国大陆',
    language: '汉语普通话',
    updateDay: '已上映',
    isHot: false,
    isNew: false,
    tags: ['古装', '悬疑', '喜剧', '剧情'],
    releaseDate: '2023-01-22',
    duration: '159分钟',
  },
  {
    id: '15',
    title: '地球脉动 第三季',
    categorySlug: 'jilupian',
    categoryName: '纪录片',
    subcategory: '自然',
    image: 'https://readdy.ai/api/search-image?query=Breathtaking%20aerial%20view%20of%20diverse%20ecosystems%20from%20rainforests%20to%20deserts%20to%20oceans%2C%20wildlife%20in%20natural%20habitats%2C%20stunning%20nature%20photography%20style%2C%20stylized%20illustration%20with%20rich%20vibrant%20greens%20and%20earthy%20tones%2C%20documentary%20aesthetic&width=800&height=600&seq=show-diqiu3&orientation=landscape',
    description: 'BBC经典自然纪录片回归！从冰封极地到热带雨林，探索地球最壮丽的自然奇观。',
    longDescription: '《地球脉动》第三季延续了系列一贯的高水准制作，摄制组历时四年，走遍全球六大洲四十余个国家。从深海的荧光生物到高山的雪豹猎食，从沙漠中的大象迁徙到雨林中的树冠世界，每一帧画面都是对地球生命的礼赞。本季更关注气候变化对野生动物的影响，引发人们对生态保护的深思。',
    rating: 9.7,
    year: 2024,
    episodes: '8集全',
    actors: [],
    director: 'BBC Studios',
    region: '英国',
    language: '英语',
    updateDay: '已完结',
    isHot: true,
    isNew: true,
    tags: ['自然', '动物', '地理', '科普'],
    releaseDate: '2024-02-18',
    duration: '60分钟/集',
  },
  {
    id: '16',
    title: '歌手 2024',
    categorySlug: 'zongyi',
    categoryName: '综艺',
    subcategory: '音乐竞技',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20concert%20stage%20with%20spotlights%20and%20musical%20instruments%2C%20grand%20performance%20atmosphere%20with%20purple%20and%20golden%20lighting%2C%20stylized%20illustration%20with%20dynamic%20energy%2C%20music%20competition%20vibe&width=800&height=600&seq=show-geshou2024&orientation=landscape',
    description: '华语乐坛顶级歌手同台竞技，用歌声点燃舞台，谁将问鼎歌王宝座？',
    longDescription: '《歌手2024》全新升级回归！本季汇聚了华语乐坛最具实力的歌手阵容，从流行到摇滚，从民谣到R&B，多元音乐风格在舞台上碰撞出耀眼火花。全程直播的形式让每一场竞演都充满悬念与惊喜，歌手们用最真实的声音征服观众。每周激烈的排名变化，让这场音乐盛宴悬念迭起。',
    rating: 8.0,
    year: 2024,
    episodes: '更新至第12期',
    actors: ['那英', '汪苏泷', '杨丞琳', '海来阿木'],
    director: '',
    region: '中国大陆',
    language: '汉语普通话',
    updateDay: '每周五更新',
    isHot: true,
    isNew: true,
    tags: ['音乐', '竞技', '直播', '实力'],
    releaseDate: '2024-05-10',
    duration: '120分钟/期',
  },
  {
    id: '17',
    title: '莲花楼',
    categorySlug: 'dianshiju',
    categoryName: '电视剧',
    subcategory: '古装武侠',
    image: 'https://readdy.ai/api/search-image?query=Misty%20Chinese%20mountain%20temple%20with%20lotus%20pond%20and%20ancient%20pavilions%2C%20martial%20arts%20atmosphere%20with%20flowing%20silk%20robes%2C%20stylized%20illustration%20with%20soft%20pink%20and%20jade%20green%20tones%2C%20peaceful%20yet%20mysterious%20composition&width=800&height=600&seq=show-lianhualou&orientation=landscape',
    description: '闻名武林的四顾门门主李相夷重伤后退隐成为江湖游医李莲花，却再次卷入江湖风波。',
    longDescription: '十年前，四顾门门主李相夷以一身绝世武功闻名天下。一场大战后，他重伤退隐，化名为李莲花，做起了江湖游医。本想远离纷争，却因一桩桩离奇案件再次卷入江湖恩怨。在追查真相的过程中，李莲花结识了方多病和笛飞声，三人之间的羁绊与友情在生死考验中愈发深厚。',
    rating: 8.6,
    year: 2023,
    episodes: '40集全',
    actors: ['成毅', '曾舜晞', '肖顺尧', '陈都灵'],
    director: '郭虎',
    region: '中国大陆',
    language: '汉语普通话',
    updateDay: '已完结',
    isHot: true,
    isNew: false,
    tags: ['古装', '武侠', '悬疑', '友情'],
    releaseDate: '2023-07-23',
    duration: '45分钟/集',
  },
  {
    id: '18',
    title: '海贼王',
    categorySlug: 'dongman',
    categoryName: '动漫',
    subcategory: '热血冒险',
    image: 'https://readdy.ai/api/search-image?query=Pirate%20ship%20sailing%20on%20vast%20ocean%20with%20dramatic%20sunset%20sky%2C%20adventure%20spirit%20with%20skull%20flag%20waving%2C%20stylized%20illustration%20with%20warm%20golden%20and%20deep%20blue%20tones%2C%20epic%20journey%20composition&width=800&height=600&seq=show-haizeiwang&orientation=landscape',
    description: '路飞和他的草帽一伙，继续在伟大航路上寻找传说中的One Piece！冒险永不停歇！',
    longDescription: '蒙奇·D·路飞，一个受到红发香克斯启发，梦想成为海贼王的少年。他召集了一群志同道合的伙伴——索隆、娜美、乌索普、山治、乔巴、罗宾、弗兰奇、布鲁克、甚平，驾驶着桑尼号在伟大航路上展开了一场又一场惊心动魄的冒险。二十余年来，这段旅程感动了全世界的观众。',
    rating: 9.2,
    year: 1999,
    episodes: '更新至1100+集',
    actors: ['田中真弓', '中井和哉', '冈村明美'],
    director: '宇田钢之介',
    region: '日本',
    language: '日语',
    updateDay: '每周日更新',
    isHot: true,
    isNew: false,
    tags: ['热血', '冒险', '友情', '经典'],
    releaseDate: '1999-10-20',
    duration: '24分钟/集',
  },
  {
    id: '19',
    title: '向往的生活 第八季',
    categorySlug: 'zongyi',
    categoryName: '综艺',
    subcategory: '慢生活',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20countryside%20farmhouse%20with%20green%20fields%20and%20vegetable%20garden%2C%20peaceful%20rural%20life%20with%20warm%20sunlight%2C%20stylized%20illustration%20with%20natural%20soft%20colors%2C%20homely%20and%20relaxing%20atmosphere&width=800&height=600&seq=show-xiangwang8&orientation=landscape',
    description: '远离城市喧嚣，回归田园生活。黄磊、何炅携新老朋友，在蘑菇屋续写向往的生活。',
    longDescription: '《向往的生活》第八季来到了风景如画的云南大理。在这里，黄磊和何炅带着年轻的朋友们，过着自给自足的田园生活——种菜、做饭、聊天、发呆。每一期都有老朋友和新面孔来做客，带来各自的故事和美食。在这个快节奏的时代，蘑菇屋就像一个让人慢下来的避风港。',
    rating: 7.8,
    year: 2024,
    episodes: '更新至第10期',
    actors: ['黄磊', '何炅', '张艺兴', '彭昱畅'],
    director: '',
    region: '中国大陆',
    language: '汉语普通话',
    updateDay: '每周六更新',
    isHot: false,
    isNew: true,
    tags: ['慢生活', '美食', '田园', '治愈'],
    releaseDate: '2024-04-26',
    duration: '90分钟/期',
  },
  {
    id: '20',
    title: '奥本海默',
    categorySlug: 'dianying',
    categoryName: '电影',
    subcategory: '传记剧情',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20black%20and%20white%20nuclear%20explosion%20mushroom%20cloud%20silhouette%20against%20dark%20sky%2C%20intense%20biographical%20drama%20atmosphere%2C%20stylized%20illustration%20with%20stark%20contrast%20and%20orange%20fire%20highlights%2C%20somber%20and%20powerful%20composition&width=800&height=600&seq=show-aobenheimer&orientation=landscape',
    description: '原子弹之父罗伯特·奥本海默的传奇一生——从科学巅峰到道德困境的史诗级传记。',
    longDescription: '克里斯托弗·诺兰执导的史诗级传记电影，讲述了"原子弹之父"罗伯特·奥本海默的传奇一生。从曼哈顿计划的科学领袖，到原子弹爆炸后的道德拷问，影片以震撼的视听语言展现了这位天才科学家的辉煌与挣扎。基里安·墨菲的精湛演技，将奥本海默内心的矛盾与痛苦刻画得淋漓尽致。',
    rating: 8.8,
    year: 2023,
    episodes: '180分钟',
    actors: ['基里安·墨菲', '艾米莉·布朗特', '马特·达蒙', '小罗伯特·唐尼'],
    director: '克里斯托弗·诺兰',
    region: '美国/英国',
    language: '英语',
    updateDay: '已上映',
    isHot: true,
    isNew: false,
    tags: ['传记', '剧情', '历史', '战争'],
    releaseDate: '2023-08-30',
    duration: '180分钟',
  },
];

// ============ 首页数据 ============
export const heroSlides = shows.filter((s) => s.isHot).slice(0, 4);

export const hotShows = shows.filter((s) => s.isHot).slice(0, 8);

export const newShows = shows.filter((s) => s.isNew).slice(0, 8);

export const featuredByCategory = (slug: string) =>
  shows.filter((s) => s.categorySlug === slug).slice(0, 6);

// ============ 面包屑配置 ============
export const breadcrumbMap: Record<string, string> = {
  '': '首页',
  dianshiju: '电视剧',
  dianying: '电影',
  dongman: '动漫',
  zongyi: '综艺',
  jilupian: '纪录片',
  about: '关于我们',
};

// ============ FAQ 数据 ============
export const faqs = [
  {
    q: '屁屁影院的视频需要收费吗？',
    a: '完全免费！屁屁影院所有电视剧、电影、动漫、综艺、纪录片均免费在线观看，无需注册，无需付费。我们坚持为用户提供最优质的免费观影体验。',
  },
  {
    q: '为什么有些剧集需要缓冲？',
    a: '屁屁影院采用先进的CDN加速技术，绝大多数视频均可实现高清秒播、不缓冲。如果您遇到缓冲问题，建议检查网络连接或尝试切换清晰度。',
  },
  {
    q: '屁屁影院每天更新多少内容？',
    a: '我们每天都会更新大量内容！包括最新热播剧集的同步更新、热门电影的及时上线，以及经典剧集的优化补档。确保您每天都能找到想看的内容。',
  },
  {
    q: '支持哪些设备观看？',
    a: '屁屁影院支持全平台观看！您可以在电脑、手机、平板等设备上流畅观看。网页采用响应式设计，自动适配不同屏幕尺寸，随时随地追剧无忧。',
  },
  {
    q: '剧集资源完整吗？会不会有删减？',
    a: '屁屁影院提供剧集完整版在线观看，确保您能看到最完整的剧情内容。我们致力于为用户提供完整、无删减的观影体验，一追到底，不留遗憾。',
  },
  {
    q: '如何找到我想看的剧集？',
    a: '您可以通过首页的搜索框直接搜索想看的剧集名称，也可以点击分类标签（电视剧、电影、动漫、综艺、纪录片）浏览对应类型的内容。首页还设有热门推荐和最新更新专区，帮您快速发现好内容。',
  },
  {
    q: '屁屁影院有广告吗？',
    a: '屁屁影院以用户体验为先，尽最大努力减少广告干扰。我们力求在维持运营的同时，为用户提供清爽、流畅的观影环境。',
  },
];

// ============ 关于我们数据 ============
export const aboutInfo = {
  brandName: '屁屁影院',
  brandIntro:
    '屁屁影院成立于2020年，是一家专注于提供高品质免费影视内容在线观看的平台。我们致力于为用户打造"高清流畅、不缓冲、剧集完整"的极致观影体验，让每一位用户都能轻松畅享影视世界。',
  mission:
    '让每一个人都能免费享受高品质的影视内容，追剧无忧，观影无界。',
  vision:
    '成为中文互联网最受欢迎的一站式免费影视平台，让好内容触手可及。',
  values: [
    { title: '用户至上', desc: '一切以用户体验为核心，持续优化观影品质' },
    { title: '内容为王', desc: '精选优质内容，满足不同用户的多元化观影需求' },
    { title: '技术创新', desc: '不断优化播放技术，实现高清秒播不缓冲的流畅体验' },
    { title: '开放共享', desc: '坚持免费开放的运营理念，让好内容服务更多人' },
  ],
  stats: [
    { value: '50000+', label: '影视资源' },
    { value: '1000万+', label: '月活用户' },
    { value: '99.9%', label: '播放成功率' },
    { value: '24h', label: '内容更新' },
  ],
  contact: {
    email: 'contact@pipicinema.com',
    wechat: '屁屁影院官方',
    weibo: '@屁屁影院',
    address: '',
  },
};